// extracted by mini-css-extract-plugin
export var button = "_dx-7";
export var buttonRow = "_dx-6";
export var fadeIn = "_dx-1";
export var gradient = "_dx-0";
export var panel = "_dx-2";
export var panelIn = "_dx-3";
export var subtitle = "_dx-5";
export var title = "_dx-4";